export default "__VITE_ASSET__jv9s_jjw__"